import { Box } from "@ecco/ui/box";
import type { SelectDropdownProps } from "@ecco/ui/select-dropdown";
import { SelectDropdown, SelectDropdownButton, SelectDropdownList } from "@ecco/ui/select-dropdown";
import { memo, useRef, type JSX } from "react";
import { breakpoints } from "@ecco/ui/tokens";

interface FilterBaseComponentProps {
    filterName: string;
    dropdownItems: JSX.Element;
    isToolbar?: boolean;
    closeOnSelect?: boolean;
    isLoading?: boolean;
    placement?: SelectDropdownProps["placement"];
    gutter?: SelectDropdownProps["gutter"];
    onOpen?: () => void;
    onClose?: () => void;
}

const FilterBaseComponent = ({
    filterName,
    dropdownItems,
    isToolbar = true,
    placement,
    closeOnSelect = false,
    gutter,
    onOpen,
    onClose,
}: FilterBaseComponentProps) => {
    const menuButtonRef = useRef(undefined);

    return (
        <Box zIndex={9} sx={!isToolbar ? { display: "none" } : {}}>
            <SelectDropdown
                onOpen={onOpen}
                onClose={onClose}
                gutter={gutter ?? 1}
                closeOnSelect={closeOnSelect}
                boundary={"scrollParent"}
                flip={false}
                placement={placement}
            >
                {({ isOpen }) => (
                    <>
                        <SelectDropdownButton
                            zIndex={1}
                            ref={menuButtonRef}
                            data-testid={filterName}
                            sx={{
                                fontWeight: "bold",
                                bgColor: "white",
                                height: 10,
                                width: "fit-content",
                                border: "none",
                                shadow: "base",
                                backdropFilter: `blur(7.5px)`,
                                _focus: { shadow: "base" },
                                _active: { shadow: "base" },
                                [`@media (max-width: ${breakpoints.sm})`]: {
                                    whiteSpace: "normal",
                                },
                            }}
                        >
                            {filterName}
                        </SelectDropdownButton>
                        {isOpen && <SelectDropdownList>{dropdownItems}</SelectDropdownList>}
                    </>
                )}
            </SelectDropdown>
        </Box>
    );
};

export const FilterBase = memo(FilterBaseComponent);
